/*
  Window forms are in testing: only the people below can start a new one from
  /forms/new/rfq. Everyone else sees "coming soon" in the form picker.

  Note "Window/Door - Mishawaka" is matched against user.branch, NOT roles.
  Role strings in this app look like "Window Door Manager" / "Window Door
  Staff"; this exact string only ever appears as a branch value (see
  HomeWeatherWidget and HeaderWeather).

  To open window forms to everyone, set WINDOW_FORMS_OPEN_TO_ALL to true — then
  this whole module and its use in SelectFormStep can be deleted.
*/
export const WINDOW_FORMS_OPEN_TO_ALL = false;

export const WINDOW_FORMS_TEST_ROLES = ["Admin", "Window Door Manager"];

export const WINDOW_FORMS_TEST_BRANCHES = ["Window/Door - Mishawaka"];

export const canAccessWindowForms = (user, roleList) => {
  if (WINDOW_FORMS_OPEN_TO_ALL) return true;

  // Mirrors App.js's RequireRoles: the roleSlice is authoritative when it has
  // loaded, with the user object as the fallback.
  const roles = roleList?.length ? roleList : user?.roles || [];
  if (WINDOW_FORMS_TEST_ROLES.some((role) => roles.includes(role))) {
    return true;
  }

  return WINDOW_FORMS_TEST_BRANCHES.includes(user?.branch);
};
